<template>
  <Modal v-model="viewCustomizedInfoModal" :title="$t('key1001525')" width="800" class-name="commonModalStyles"
    :transfer="false" :mask-closable="false">
    <div slot="header" class="flex align-items-center">
      <h2 class="mr5 font-size-15 font-weight-bold">{{ $t('key1001525') }}</h2>
      <Tooltip :content="$t('key1001526')" max-width="500" placement="top" transfer>
        <Icon :color="system !== 'distributor' ?'#2D8CF0' : '#FD5425'" type="md-alert" class="cursor mr3" size="17"/>
      </Tooltip>
    </div>
    <h3 class="font-size-13 cursor text-align-right mb8" :class="system === 'distributor' ? 'distributorThemeColor' : 'themeColor'"
      @click="oneClickDownloadBtn">{{ $t('key1001527') }}</h3>
    <div class="viewCustomizedInfo_box" v-for="item in viewCustomizedInfoList" v-viewer="viewerOptions">
      <div class="viewCustomizedInfo_img mb15">
        <div class="img_box">
          <img :src="setImgPath(item.primaryImage, null, null, null, false)" alt="">
        </div>
        <div class="ml12">
          <h2 class="font-size-14 color-333 font-weight-bold ellipsis_1" :title="item.name">{{ item.name }}</h2>
          <p>{{ configCharacters(false) + 'SPU：' + item.ymsSpu }}</p>
          <p>{{ configCharacters(false) + 'SKU：' + item.newYmsSku }}</p>
          <p :class="system !== 'distributor' ? 'themeColor' : 'distributorThemeColor'">{{ item.specifications }}</p>
        </div>
        <P class="ml30">{{ '* ' + item.quantity }}</P>
      </div>
      <div class="viewCustomizedInfo_content" v-for="ele in item.ymsPackageGoodsCsList">
        <div class="width_200 pr20">{{ $t('key1001310') + ele.parts }}</div>
        <div class="flex align-items-start width_280">
          <span>{{ $t('key1001528') }}</span>
          <div class="imgagesList_box" v-if="ele.ymsPackageGoodsCisList.length >0">
            <div class="imgagesList_box_item" v-for="(k,idx) in ele.ymsPackageGoodsCisList.filter((j) => j.type === 1)" :key="idx">
              <div class="img_content">
                <span class="clickOnCrop_box">{{ $t('key1000720') }}</span>
                <img class="img-styles" :src="setImgPath(k.path, null, null, null, false)" @error="setErrorImg($event)" alt=""/>
              </div>
            </div>
          </div>
        </div>
        <div class="flex align-items-start width_280">
          <span>{{ $t('key1001529') }}</span>
          <div class="imgagesList_box" v-if="ele.ymsPackageGoodsCisList.length >0">
            <div class="imgagesList_box_item" v-for="(k,idx) in ele.ymsPackageGoodsCisList.filter((j) => j.type === 2)" :key="idx">
              <div class="img_content">
                <span class="clickOnCrop_box">{{ $t('key1000720') }}</span>
                <img class="img-styles" :src="setImgPath(k.path, null, null, null, false)" @error="setErrorImg($event)" alt=""/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <Button type="primary" @click="viewCustomizedInfoModal = false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {downloadTemplateFile} from "@/utils/common";

export default {
  name: 'viewCustomizedInfoModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      viewCustomizedInfoModal: false,
      viewCustomizedInfoList: [],
      ymsPackageId: null,
      packageId: null,
    }
  },
  methods: {
    // 初始化数据
    async initViewCustomizedInfoData(obj) {
      const v = this;
      v.viewCustomizedInfoList = [];
      v.viewCustomizedInfoModal = true; // 先打开弹窗
      // 请求和处理数据的统一方法
      const fetchData = async (url, id, isYms) => {
        const response = await v.axios.get(url + id, {loading: true});
        if (response.data.code !== 0) return [];
        const data = response.data.datas || [];
        const list = data.filter(item => item.isNeedCustomization === 1);
        list.forEach(item => item.newYmsSku = item.ymsSku);

        const ids = (isYms
          ? list.map(i => i.ymsProductGoodsId).filter(id => id)
          : list.map(i => i.productGoodsId).filter(id => id));
        if (ids.length === 0) return [];
        const newData = await v.getProductInfoByIds(
          v.uniqueFunc(ids),
          list,
          false, false, false,
          isYms ? null : api.post_productInfo_queryByProductGoodsIds,
          isYms ? 'yms' : 'supplier'
        );

        newData.forEach(item => {
          const info = item._productInfo || {};
          let specs = isYms ? info.productGoodsSpecificationList : info.productGoodsSpecifications;
          if (isYms) {
            specs = specs.filter(spec => !spec.ymsProductGoodsSpecificationImages || spec.ymsProductGoodsSpecificationImages.length === 0);
          } else {
            specs = specs.filter(spec => !spec.productGoodsSpecificationImages || spec.productGoodsSpecificationImages.length === 0);
            item.name = info._spuInfo?.name;
          }
          item.specifications = specs.map(s => s.value).join(' • ') || '';
          item.primaryImage = info.primaryImage || info._spuInfo?.primaryImage;
          item.ymsPackageGoodsCsList = item.ymsPackageGoodsCs || item.packageGoodsCS || [];
          item.ymsPackageGoodsCsList.map((ele) => {
            ele.ymsPackageGoodsCisList = ele.ymsPackageGoodsCis || ele.packageGoodsCis || [];
          })
        });
        return newData;
      };

      switch (v.system) {
        case 'yms':
          v.ymsPackageId = obj.ymsPackageId;
          v.viewCustomizedInfoList = await fetchData(api.get_ymsPackageInfo_queryCustomizationGoods, obj.ymsPackageId, true);
          break;
        case 'supplier':
          v.packageId = obj.packageId;
          v.viewCustomizedInfoList = await fetchData(api.get_packageInfo_queryCustomizationGoods, obj.packageId, false);
          break;
        case 'distributor':
          v.ymsPackageId = obj.ymsPackageId;
          v.viewCustomizedInfoList = await fetchData(api.get_ymsPackageGoods_api_queryByYmsPackageId, obj.ymsPackageId, true);
          break;
      }
    },
    // 一键下载全部图片
    oneClickDownloadBtn() {
      const handleData = (url) => {
        this.axios.get(url, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let url = response.data.datas;
            if (url) {
              downloadTemplateFile(url);
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001523'));
            } else {
              this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001524'));
              return false;
            }
          }
        });
      }
      switch (this.system) {
        case 'yms':
          handleData(api.get_ymsPackageInfo_downloadCustomizedInfo + this.ymsPackageId)
          break;
        case 'supplier':
          handleData(api.get_packageInfo_downloadCustomizedInfo + this.packageId)
          break;
        case 'distributor':
          handleData(api.get_ymsDistributorPackageInfo_downloadCustomizedInfo + this.ymsPackageId)
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .commonModalStyles {
  .viewCustomizedInfo_box {
    margin-bottom: 24px;

    .viewCustomizedInfo_img {
      display: flex;
      align-items: center;
      padding: 15px;
      border-radius: 5px;
      border: 2px solid #DAEAFD;
      background-color: #FBFDFF;

      .img_box {
        cursor: pointer;
        width: 80px;
        height: 80px;
        position: relative;

        img {
          display: inline-block;
          left: 50%;
          max-height: 100%;
          max-width: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%) translateX(-50%);
        }
      }
    }

    .viewCustomizedInfo_content {
      display: flex;
      align-items: flex-start;
      margin-bottom: 12px;

      .imgagesList_box {
        display: flex;
        flex-wrap: wrap;
        position: relative;

        .imgagesList_box_item {
          margin: 0 8px 0 0;

          .img_content {
            position: relative;
            cursor: pointer;
            width: 80px;
            height: 80px;

            .clickOnCrop_box {
              width: 100%;
              height: 20px;
              line-height: 20px;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 10;
              text-align: center;
              font-size: 12px;
              color: #fff;
              background-color: #ada9a9;
              display: none;
            }

            &:hover {
              .clickOnCrop_box {
                display: inline-block;
              }
            }
          }

          .img-styles {
            width: 80px;
            height: 80px;
            object-fit: cover;
            border: 1px solid #ddd;
          }
        }
      }
    }
  }
}
</style>
